<div class="card b">
  <div class="card-header bg-gray-lighter text-bold">
    <div>
      <h4 class="m-0 mb-4">
        {{
          "navigation.links.customer.profile.subcategories.titles.USERPROFILE" | translate
        }}
      </h4>
    </div>
  </div>
  <div class="nt-loading-shade" *ngIf="isLoadingResults">
    <mat-spinner color="primary" *ngIf="isLoadingResults"></mat-spinner>
  </div>
  <div class="card-body">
    <form [formGroup]="userForm">
      <div class="row">
        <div class="col-md-6">
          <div class="mda-form-group">
            <mat-form-field>
              <mat-label>{{
                "forms.labels.organisation.FIRSTNAME" | translate
              }}</mat-label>
              <input matInput formControlName="firstname" required="" type="text" />
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mda-form-group">
            <mat-form-field>
              <mat-label>{{
                "forms.labels.organisation.LASTNAME" | translate
              }}</mat-label>
              <input matInput formControlName="lastname" required type="text" />
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mda-form-group">
            <mat-form-field>
              <mat-label>{{ "forms.labels.organisation.EMAIL" | translate }}</mat-label>
              <input matInput formControlName="email" required="" type="text" />
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mda-form-group">
            <mat-form-field>
              <mat-label>{{
                "forms.labels.organisation.LANGUAGE" | translate
              }}</mat-label>
              <mat-select
                formControlName="language"
                required
                (selectionChange)="changeLanguage($event)"
              >
                <mat-option *ngFor="let lang of langs" [value]="lang.code">
                  {{ lang.text | translate }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mda-form-group">
            <mat-form-field>
              <mat-label>{{
                "forms.labels.organisation.DATETIME_FORMAT" | translate
              }}</mat-label>
              <mat-select
                formControlName="dateTimeFormat"
                required
                (selectionChange)="changeDateTimeFormat($event)"
              >
                <mat-option *ngFor="let locale of locales" [value]="locale.code">
                  {{ locale.displayName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
    </form>

    <div class="text-right mt-3">
      <button
        class="btn btn-success wd-sd"
        [disabled]="!userForm.valid"
        (click)="updateUser()"
      >
        {{ "buttons.SAVE" | translate }}
      </button>
    </div>
  </div>
</div>
